















































































































































































import Vue from "vue";
import storeHelper from "../../store/store-helper";
import _ from "lodash";
import i18n from "@/plugins/i18n";
import { Portal } from "@infoland/iprova-api";
import { SearchScope, PortalSearchOptions } from "@/types/portal";
import VueI18n from "vue-i18n";
import { debounce } from "@/utils";
import Shared from "@/shared";

export default Vue.extend({
    name: "SearchComponent",
    props: {
        showDropdown: Boolean,
        searchText: String,
        portalId: Number,
        scope: { default: "portal" as SearchScope },
        autocomplete: Boolean,
        getAutoCompleteItems: { type: Function, required: false },
        disabled: Boolean,
        hoverDisabledMessage: String,
        currentPortalDisabled: { default: false },
        hoverCurrentPortalDisabledMessage: String,
        instantSearch: Boolean,
        hideSearchButton: { type: Boolean, default: false },
        searchOnClear: { default: false, type: Boolean }
    },
    data: function () {
        return {
            search: this.searchText,
            entries: [],
            searchItems: null,
            isLoading: false,
            currentScope: this.scope,
            aiSearchEnabled: false as boolean
        };
    },
    computed: {
        portal(): Portal {
            if (this.portalId) return storeHelper.portalStore.getPortal(this.portalId);
            else return null;
        },
        scopeOptions(): { text: string | VueI18n.TranslateResult; scope: SearchScope; disabled: boolean }[] {
            //add empty scope options
            let scopeOptions: { text: string | VueI18n.TranslateResult; scope: SearchScope; disabled: boolean }[] = [];

            //if ai search is enabled, then add the ai search option as well
            if (this.aiSearchEnabled) {
                scopeOptions.push({
                    text: this.$t("portal.labels.searchWithAi"),
                    scope: "ai",
                    disabled: false
                });
            }

            //add default scope options
            let defaultScopeOptions: { text: string | VueI18n.TranslateResult; scope: SearchScope; disabled: boolean }[] = [
                {
                    text: this.$t("portal.labels.searchIn", { currentPortalNameParam: this.portal?.name }),
                    scope: "portal",
                    disabled: this.currentPortalDisabled
                },
                {
                    text: this.$t("portal.labels.searchInAllPortals"),
                    scope: "global",
                    disabled: false
                }
            ];

            // concat ai and default scope options
            scopeOptions = scopeOptions.concat(defaultScopeOptions);
            return scopeOptions;
        },
        scopeTranslation(): any {
            return this.scopeOptions.find(x => x.scope == this.currentScope).text;
        },
        items(): any[] {
            return this.entries.map(entry => entry.search_query);
        },
        smAndDown(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        },
        searchWatermark(): any {
            return this.smAndDown && this.autocomplete
                ? i18n.t("portal.labels.searchWatermarkMobile", { portalName: this.scopeTranslation })
                : i18n.t("portal.labels.searchWatermark");
        },
        searchIcon(): string {
            return this.aiSearchEnabled && this.currentScope == "ai" ? "$ai_assistant" : "search";
        },
        baseUrl(): string {
            return Shared.iProvaUrl;
        }
    },
    created() {
        if (this.currentScope == "ai") {
            this.applyAiSearch();
        }
    },
    methods: {
        doGetAutocompleteItems: debounce(async function (this: any, searchedVal: string): Promise<void> {
            if (this.autocomplete && this.getAutoCompleteItems && searchedVal != undefined && searchedVal != "") {
                this.isLoading = true;
                //$nextTick to work around possible Vuetify bug
                this.$nextTick(async () => {
                    this.entries = await this.getAutoCompleteItems(searchedVal);
                });
                this.isLoading = false;
            } else {
                this.entries = [];
            }
        }, 500),
        doSearch() {
            //Make sure to defocus the search combobox
            if (this.autocomplete) (this.$refs.searchCombobox as HTMLElement).blur();
            this.$emit("search", { text: this.search?.trim(), scope: this.currentScope } as PortalSearchOptions);
        },
        onChange(value) {
            if (this.autocomplete && _.find(this.items, { search_query: value })) {
                this.search = value;
                this.doSearch();
            } else if (!value && this.searchOnClear) {
                this.search = value;
                this.doSearch();
            }
        },
        onInstantChange(value) {
            if (this.instantSearch) {
                this.search = value;
                this.doSearch();
            }
        },
        applyAiSearch() {
            this.aiSearchEnabled = true;
        }
    },
    watch: {
        scope(val: SearchScope) {
            if (val == this.currentScope) return;
            if (val == "ai") {
                this.applyAiSearch();
            }
            this.currentScope = val;
        },
        searchText(val: string) {
            //update data
            this.search = val;
        },
        searchItems(val) {
            this.search = val;
            if (val && val.trim().length > 1) this.doGetAutocompleteItems(val); //fix for bug 64937 only get auto complete items when we have actual input
        }
    }
});
